/* tslint:disable */
/* eslint-disable */
/**
 * Pitango Market API
 * Canonical public and administrative HTTP API contract.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    ApiErrorEnvelope,
    ShippingAddressesRequestCreateShippingAddressRequest,
    ShippingAddressesRequestUpdateShippingAddressRequest,
    ShippingAddressesResponseCreateShippingAddressResponse,
    ShippingAddressesResponseDeleteShippingAddressResponse,
    ShippingAddressesResponseListShippingAddressesResponse,
    ShippingAddressesResponseSetDefaultShippingAddressResponse,
    ShippingAddressesResponseUpdateShippingAddressResponse,
} from '../models/index';

export interface ShippingAddressesCreateRequest {
    shippingAddressesRequestCreateShippingAddressRequest: ShippingAddressesRequestCreateShippingAddressRequest;
}

export interface ShippingAddressesDeleteRequest {
    shippingAddressId: string;
}

export interface ShippingAddressesSetDefaultRequest {
    shippingAddressId: string;
}

export interface ShippingAddressesUpdateRequest {
    shippingAddressId: string;
    shippingAddressesRequestUpdateShippingAddressRequest: ShippingAddressesRequestUpdateShippingAddressRequest;
}

/**
 *
 */
export class ShippingAddressesApi extends runtime.BaseAPI {

    /**
     * Creates request options for shippingAddressesCreate without sending the request
     */
    async shippingAddressesCreateRequestOpts(requestParameters: ShippingAddressesCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shippingAddressesRequestCreateShippingAddressRequest'] == null) {
            throw new runtime.RequiredError(
                'shippingAddressesRequestCreateShippingAddressRequest',
                'Required parameter "shippingAddressesRequestCreateShippingAddressRequest" was null or undefined when calling shippingAddressesCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/shipping-addresses`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['shippingAddressesRequestCreateShippingAddressRequest'],
        };
    }

    /**
     * Create
     */
    async shippingAddressesCreateRaw(requestParameters: ShippingAddressesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShippingAddressesResponseCreateShippingAddressResponse>> {
        const requestOptions = await this.shippingAddressesCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create
     */
    async shippingAddressesCreate(requestParameters: ShippingAddressesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShippingAddressesResponseCreateShippingAddressResponse> {
        const response = await this.shippingAddressesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shippingAddressesDelete without sending the request
     */
    async shippingAddressesDeleteRequestOpts(requestParameters: ShippingAddressesDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shippingAddressId'] == null) {
            throw new runtime.RequiredError(
                'shippingAddressId',
                'Required parameter "shippingAddressId" was null or undefined when calling shippingAddressesDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/shipping-addresses/{shippingAddressId}`;
        urlPath = urlPath.replace('{shippingAddressId}', encodeURIComponent(String(requestParameters['shippingAddressId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete
     */
    async shippingAddressesDeleteRaw(requestParameters: ShippingAddressesDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShippingAddressesResponseDeleteShippingAddressResponse>> {
        const requestOptions = await this.shippingAddressesDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Delete
     */
    async shippingAddressesDelete(requestParameters: ShippingAddressesDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShippingAddressesResponseDeleteShippingAddressResponse> {
        const response = await this.shippingAddressesDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shippingAddressesList without sending the request
     */
    async shippingAddressesListRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/shipping-addresses`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List
     */
    async shippingAddressesListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShippingAddressesResponseListShippingAddressesResponse>> {
        const requestOptions = await this.shippingAddressesListRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List
     */
    async shippingAddressesList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShippingAddressesResponseListShippingAddressesResponse> {
        const response = await this.shippingAddressesListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shippingAddressesSetDefault without sending the request
     */
    async shippingAddressesSetDefaultRequestOpts(requestParameters: ShippingAddressesSetDefaultRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shippingAddressId'] == null) {
            throw new runtime.RequiredError(
                'shippingAddressId',
                'Required parameter "shippingAddressId" was null or undefined when calling shippingAddressesSetDefault().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/shipping-addresses/{shippingAddressId}/default`;
        urlPath = urlPath.replace('{shippingAddressId}', encodeURIComponent(String(requestParameters['shippingAddressId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Set Default
     */
    async shippingAddressesSetDefaultRaw(requestParameters: ShippingAddressesSetDefaultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShippingAddressesResponseSetDefaultShippingAddressResponse>> {
        const requestOptions = await this.shippingAddressesSetDefaultRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Set Default
     */
    async shippingAddressesSetDefault(requestParameters: ShippingAddressesSetDefaultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShippingAddressesResponseSetDefaultShippingAddressResponse> {
        const response = await this.shippingAddressesSetDefaultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shippingAddressesUpdate without sending the request
     */
    async shippingAddressesUpdateRequestOpts(requestParameters: ShippingAddressesUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shippingAddressId'] == null) {
            throw new runtime.RequiredError(
                'shippingAddressId',
                'Required parameter "shippingAddressId" was null or undefined when calling shippingAddressesUpdate().'
            );
        }

        if (requestParameters['shippingAddressesRequestUpdateShippingAddressRequest'] == null) {
            throw new runtime.RequiredError(
                'shippingAddressesRequestUpdateShippingAddressRequest',
                'Required parameter "shippingAddressesRequestUpdateShippingAddressRequest" was null or undefined when calling shippingAddressesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/shipping-addresses/{shippingAddressId}`;
        urlPath = urlPath.replace('{shippingAddressId}', encodeURIComponent(String(requestParameters['shippingAddressId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['shippingAddressesRequestUpdateShippingAddressRequest'],
        };
    }

    /**
     * Update
     */
    async shippingAddressesUpdateRaw(requestParameters: ShippingAddressesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShippingAddressesResponseUpdateShippingAddressResponse>> {
        const requestOptions = await this.shippingAddressesUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update
     */
    async shippingAddressesUpdate(requestParameters: ShippingAddressesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShippingAddressesResponseUpdateShippingAddressResponse> {
        const response = await this.shippingAddressesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
